import { render, staticRenderFns } from "./BrandsTemplate.vue?vue&type=template&id=1c404f39"
import script from "./BrandsTemplate.vue?vue&type=script&lang=js"
export * from "./BrandsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports